/**
 * Trip image URL resolver
 * Normalizes main_image from trip objects for display across the app.
 * Handles: Cloudinary URLs (absolute), backend-relative paths, and backend response shapes.
 */

const API_BASE = process.env.REACT_APP_API_URL?.replace(/\/api\/v1\/?$/, '') || 'http://localhost:4000';

/**
 * Get display-ready URL for a trip's main image
 * @param {object} trip - Trip object (may have main_image, main_image_url, image, etc.)
 * @returns {string|null} - Resolved URL or null if no image
 */
export const getTripImageUrl = (trip) => {
  if (!trip) return null;
  const raw =
    trip.main_image_url ??
    trip.main_image ??
    trip.mainImage ??
    trip.image ??
    trip.primary_image;
  if (!raw || typeof raw !== 'string') return null;
  if (raw.startsWith('http://') || raw.startsWith('https://')) return raw;
  return `${API_BASE}${raw.startsWith('/') ? raw : `/${raw}`}`;
};
